import { useLocale, useT } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

export default function About() {
  const locale = useLocale();
  const t = useT();
  const state = useApiData(() => contentApi.page('company', locale), [locale]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head reveal is-visible">
          <span className="eyebrow">{t('nav.about')}</span>
          <h1>About CYRKIL</h1>
        </div>
        <AsyncSection
          state={state}
          render={(page) => {
            const company = page.contentBlocks as any;
            return (
              <div className="card reveal is-visible" style={{ maxWidth: 680 }}>
                <p className="body-lg">{company.positioning?.[locale] ?? company.positioning?.en}</p>
                <p className="body-sm" style={{ marginTop: 24 }}>
                  {company.legal_name}
                  <br />
                  {company.address}
                  <br />
                  {company.rcs} · {company.eori}
                  <br />
                  <a href={`mailto:${company.email}`}>{company.email}</a>
                </p>
              </div>
            );
          }}
        />
        <div id="academy" className="section-head" style={{ marginTop: 64 }}>
          <span className="eyebrow">Academy</span>
          <h2>Executive, Technical, Corporate and Government programme tracks</h2>
          <p className="body-sm">How CYRKIL AI Lab research becomes capability inside your organization.</p>
        </div>
      </div>
    </section>
  );
}
